import React, { useMemo, useEffect, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import { doRequestGet } from '../../../api'
import { toast } from 'react-toastify'
import { apiResource, getDate, promiseCatch } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { FormCustom, Input } from '../../../components/form'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import ReactPlaceholder from 'react-placeholder/lib'

export const ReportEventView = () => {
  const [form, setForm] = useState({
    p_id_event: '',
    p_date_start: getDate({ addDays: -7 }),
    p_date_end: getDate(),
  })

  const [execute, setExecute] = useState(false)
  const { rows, isProcessing, setReload, error, setError, setRows } = useGet({
    url: `/event/report/${form.p_id_event}/${form.p_date_start}/${form.p_date_end}`,
    execute
  })

  const [events, setEvents] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [finalPdf, setFinalPdf] = useState('')
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const reqEvents = async () => {
      const getEvents = await doRequestGet({
        url: '/event'
      })

      setEvents(getEvents.data)
      setReady(true)
    }

    reqEvents()
  }, [])

  const dtRows = useMemo(() => {
    const headItem = [
      {
        name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: row => {
          return <>
            <Button size="xs" variant='danger text-white' onClick={_ => {
              setFinalPdf(apiResource({
                url: row.final_pdf
              }))
              setModalShow(true)
            }}>
              <i className='fa fa-file-pdf'></i>
            </Button>
          </>
        }
      },
      { name: 'date_pay', text: 'Fecha', align: 'center' },
      { name: 'name_event', text: 'Evento', align: 'center' },
      { name: 'name_event_zone', text: 'Zona', align: 'center' },
      {
        name: 'price_event_zone', text: 'Precio', align: 'center', render: r => {
          if (parseInt(r.has_price2x1) === 1) {
            return <div className='d-flex flex-column'>
              <div className='mb-2'>{parseFloat(r.price2x1).toFixed(2)}</div>
              <div className='2 badge bg-primary align-self-center'>Promo 2x1</div>
            </div>
          } else if (parseInt(r.has_coupon) === 1) {
            return <div className='d-flex flex-column'>
              <div className='mb-2'>{parseFloat(r.coupon_price).toFixed(2)}</div>
              <div className='2 badge bg-info align-self-center'>Cupón</div>
            </div>
          } else if (parseInt(r.ticket_free) === 1) {
            return <div className='d-flex flex-column'>
              <div className='mb-2'>{parseFloat(r.price_event_zone).toFixed(2)}</div>
              <div className='2 badge bg-dark align-self-center'>Cortesía</div>
            </div>
          }

          return r.price_event_zone;
        }
      },
      { name: 'charge_service_event_zone', text: 'Cargo por Servicio', align: 'center' },
      { name: 'column_row_event', text: 'Ubicación', align: 'center' },
      { name: 'name_format_pay', text: 'Método de Pago', align: 'center' },
      { name: 'name_customer', text: 'Nombre', align: 'center' },
      { name: 'last_name_customer', text: 'Apellido', align: 'center' },
      { name: 'phone_customer', text: 'Telefono', align: 'center' },
      { name: 'email_customer', text: 'Email', align: 'center' },
    ]
    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows?.data}
      isProcessing={isProcessing}
      orderDirection={'desc'}
      columnOrder={'date_pay'}
      pageLength={50}
    />
  }, [rows, isProcessing])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-12">
      <Card>
        <Card.Body>
          <ReactPlaceholder ready={ready} rows={7} showLoadingAnimation>
            <FormCustom onSubmit={_ => {
              if (!isNaN(parseInt(form.p_id_event))) {
                setReload(true)
                setExecute(true)
              }
            }} viewSubmit={false}>
              <Input
                classNameParent="col-md-6 mb-2"
                value={form.p_date_start}
                onChange={e => setForm({ ...form, p_date_start: e.target.value })}
                type="date"
                text="Fecha Inicio"
              />
              <Input
                classNameParent="col-md-6 mb-2"
                value={form.p_date_end}
                onChange={e => setForm({ ...form, p_date_end: e.target.value })}
                type="date"
                text="Fecha Fin"
              />
              <SelectCustom
                valueId={form.p_id_event}
                keyName="event"
                options={events}
                setRow={setForm}
                row={form}
                selectText="Eventos"
                onChangeAdd={_ => {
                  setRows([])
                }}
                selectPops={{
                  append: [
                    <Button type="submit">
                      <i className='fa fa-search'></i>
                    </Button>
                  ]
                }}
                showEnabled={false}
              />
            </FormCustom>
            {rows?.excel?.file ? <div className="d-flex mb-2">
              <div className='mt-2 mb-2 me-2'>
                <a href={rows?.excel?.file} download={rows?.excel?.name}>
                  <Button variant="success" className='text-white'>
                    <i className="fa fa-file-excel me-2"></i>Descargar Reporte Excel
                  </Button>
                </a>
              </div>
            </div> : ''}
            {dtRows}
          </ReactPlaceholder>
        </Card.Body>
      </Card>
      <Modal show={modalShow} onHide={_ => setModalShow(false)} backdrop="static" size="lg">
        <Modal.Header closeButton>
          <Modal.Title as="div">Descargar PDF de la venta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe src={finalPdf} title="Documento de la venta" width="100%" height="500px"></iframe>
        </Modal.Body>
      </Modal>

    </div>
  </div>
}